import storage from './storage';

function key(userId) {
  return userId ? `crm_automations_u${userId}` : 'crm_automations';
}

export const automationService = {
  getAll(userId) {
    return storage.get(key(userId), []);
  },

  saveAll(userId, rules) {
    storage.set(key(userId), rules);
  },
};
